module.exports = __webpack_public_path__ + "img/main_bt_naver-cafe.91096014.png";